<template>
    <div class="root">
        <backdrop-loader :isLoading="loading"/>
        <div class="controls">
            <div class="controls-labels"ß>
                <p style="margin-right: auto">
                    Total Values: <b>{{ this.model.length }}</b>
                    <br />
                    Input is from event field: <a :href="variableLink"><b>{{ this.variable.path }}</b>
                    using comparison: <b>{{ this.variable.lookup_value_comparison_operator ?? "equals" }}</b></a>
                </p>
                <div v-show="haveChanges" class="alert alert-danger m-b-sm p-sm"
                     style="background-color: #ffebeb;margin-top: 10px;">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"/>
                    <strong>Warning!</strong>
                    You have unsaved changes.
                </div>
            </div>
            <div class="controls-buttons">
                <button
                    :disabled="!editable"
                    tye="button"
                    class="btn v2_btn v2_btn-primary v2_btn-transparent"
                    @click="onSaveHandler"
                >
                    Save
                </button>
                <button
                    tye="button"
                    class="btn v2_btn v2_btn-primary v2_btn-transparent"
                    @click="onReloadHandler"
                >
                    Reload
                </button>
                <button
                    :disabled="!editable"
                    type="button"
                    class="action-btn b-shadow color-green"
                    ref="addBtn"
                    @click="addBtnHandler"
                >
                    <i class="fa fa-plus" aria-hidden="true"/>
                </button>
            </div>
        </div>
        <div class="fixed-headers">
            <div :style="showDescription ? 'width: 103px;' : 'width: 70px;'"/>
            <h3 v-if="showDescription">Description</h3>
            <h3>Input</h3>
            <h3>Output</h3>
        </div>
        <div class="content">
            <div>
                <template v-for="(row, index) in model">
                    <div :key="row.vkey" class="b_row">
                        <div style="width: 32px;padding-left: 4px;">
                            <button
                                type="button"
                                class="action-btn b-shadow color-green"
                                ref="addBtn"
                                @click="addBtnSubLookupValue(index, row)"
                            >
                                <i class="fa fa-plus" aria-hidden="true"/>
                            </button>
                        </div>
                        <b-input
                            v-if="showDescription"
                            :disabled="!editable"
                            name="description"
                            ref="description"
                            type="text"
                            :error="errors[row.vkey] && errors[row.vkey].description"
                            spellcheck="false"
                            v-model="row.description"
                            @keydown.prevent.up="moveUp(index, 'description')"
                            @keydown.prevent.down="moveDown(index, 'description')"
                            @keydown.prevent.right="moveRight($event)"
                            @keydown.prevent.left="moveLeft($event)"
                        />
                        <b-input
                            :disabled="!editable"
                            name="input_value"
                            ref="input_value"
                            type="text"
                            placeholder="Enter an input"
                            :error="errors[row.vkey] && errors[row.vkey].input_value"
                            spellcheck="false"
                            v-model="row.input_value"
                            @keydown.prevent.up="moveUp(index, 'input_value')"
                            @keydown.prevent.down="moveDown(index, 'input_value')"
                            @keydown.prevent.right="moveRight($event)"
                            @blur="formatRange($event, row.input_value, 'input_value', index)"
                        />
                        <b-input
                            :disabled="!editable"
                            name="output_value"
                            ref="output_value"
                            type="number"
                            placeholder="Enter an output"
                            :error="errors[row.vkey] && errors[row.vkey].output_value"
                            spellcheck="false"
                            v-model="row.output_value"
                            @keydown.prevent.up="moveUp(index, 'output_value')"
                            @keydown.prevent.down="moveDown(index, 'output_value')"
                            @keydown.prevent.right="moveRight($event)"
                            @keydown.prevent.left="moveLeft($event)"
                        />
                        <div>
                            <button
                                :disabled="!editable"
                                type="button"
                                class="action-btn b-shadow color-red"
                                ref="deleteBtn"
                                @keydown.prevent.up="moveUpIcon(index, 'deleteBtn')"
                                @keydown.prevent.down="moveDownIcon(index, 'deleteBtn')"
                                @keydown.prevent.left="moveLeft($event)"
                                @click="deleteBtnHandler(row, index)"
                            >
                                <i class="fa fa-trash-o" aria-hidden="true"/>
                            </button>
                        </div>
                    </div>
                    <template v-for="(lookup_value, index_lookup_value) in row.lookup_values">
                        <div class="b_row">
                            <div v-if="index_lookup_value === 0">
                                <img src="/build/img/pricing-arrow-1.png" style="width: 28px; margin-top: -16px; margin-right: -14px; margin-left: 18px" />
                            </div>
                            <div v-else>
                                <img src="/build/img/pricing-arrow-2.png" style="width: 28px;margin-top: -42px;margin-right: -14px;margin-left: 18px;" />
                            </div>
                            <b-select
                                name="data-type"
                                v-model="lookup_value.parent_variable_id"
                                :options="variableOptions"
                                css-style="border-radius: 0;border: solid 1px #dadada;"
                            />
                            <b-input
                                :disabled="!editable"
                                name="input_value"
                                ref="input_value"
                                type="text"
                                placeholder="Enter an input"
                                :error="errors[row.vkey] && errors[row.vkey].input_value"
                                spellcheck="false"
                                v-model="lookup_value.input_value"
                                @keydown.prevent.up="moveUp(index, 'input_value')"
                                @keydown.prevent.down="moveDown(index, 'input_value')"
                                @keydown.prevent.right="moveRight($event)"
                            />
                            <b-input
                                :disabled="!editable"
                                name="output_value"
                                ref="output_value"
                                type="number"
                                placeholder="Enter an output"
                                :error="errors[row.vkey] && errors[row.vkey].output_value"
                                spellcheck="false"
                                v-model="lookup_value.output_value"
                                @keydown.prevent.up="moveUp(index, 'output_value')"
                                @keydown.prevent.down="moveDown(index, 'output_value')"
                                @keydown.prevent.right="moveRight($event)"
                                @keydown.prevent.left="moveLeft($event)"
                            />
                            <div>
                                <button
                                    type="button"
                                    class="action-btn b-shadow color-red"
                                    ref="deleteBtn"
                                    @click="deleteSubLookupValue(index, index_lookup_value)"
                                >
                                    <i class="fa fa-trash-o" aria-hidden="true"/>
                                </button>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
            <div v-if="scheduledForDelete.length > 0">
                <h3>Removed</h3>
                <div class="b_row" :key="row.vkey" v-for="(row, index) in scheduledForDelete">
                    <b-input
                        disabled
                        type="text"
                        spellcheck="false"
                        name="d_input_value"
                        v-model="row.input_value"
                    />
                    <b-input
                        disabled
                        type="number"
                        spellcheck="false"
                        name="d_output_value"
                        v-model="row.output_value"
                    />
                    <b-input
                        disabled
                        type="text"
                        spellcheck="false"
                        name="d_description"
                        v-model="row.description"
                    />
                    <button
                        type="button"
                        class="action-btn b-shadow"
                        ref="deleteBtn"
                        @keydown.prevent.up="moveUpIcon(index, 'deleteBtn')"
                        @keydown.prevent.down="moveDownIcon(index, 'deleteBtn')"
                        @click="restoreBtnHandler(row, index)"
                    >
                        <i class="fa fa-undo" aria-hidden="true"/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import uuid4 from 'uuid4'
import swal from 'sweetalert2'

import PriceMixin from './formula.mixin'
import BInput from '../../utils/b-input.vue'
import BackdropLoader from '../../utils/backdrop-loader.vue'
import BSelect from "../../utils/b-select.vue";

export default {
    components: {
        BSelect,
        BInput,
        BackdropLoader,
    },
    mixins: [PriceMixin],
    props: {
        isEditable: {
            default: false,
            type: Boolean,
        },
        variable: {
            required: true
        },
        variableLink: {
            required: true
        },
        variables: {
            required: true,
        },
        showDescription: {
            default: false,
            type: Boolean,
        }
    },
    data() {
        return {
            editable: this.isEditable,
            loading: false,
            model: [],
            errors: {},
            scheduledForDelete: [],
            lookupValues: this.variable.formula_variable_lookup_values,
            variableId: this.variable.id
        }
    },
    computed: {
        hasErrors() {
            return Object.keys(this.errors).length > 0
        },

        // Compare two arrays and return true if they are equal without considering the order
        haveChanges() {
            if (this.lookupValues.length !== this.model.length) {
                return true
            }

            for (let i = 0; i < this.lookupValues.length; i++) {
                const currentLookupValue = this.lookupValues[i]
                const found = this.model.find((m) => m.id === currentLookupValue.id)
                if (
                    !found
                    || (
                        found
                        && (found.input_value !== currentLookupValue.input_value || found.output_value !== currentLookupValue.output_value || found.description !== currentLookupValue.description)
                    )
                ) {
                    return true
                }
            }

            return false
        },

        variableOptions() {
            return this.variables.map((v) => ({
                value: v.id,
                label: v.name,
            }))
        },
    },

    methods: {
        formatRange: function (event, value, field, index) {
            // this is only for inbetween comparisons
            if (this.variable.lookup_value_comparison_operator !== 'inbetween') {
                return;
            }

            // replace empty spaces and commonly used `-` with `|`
            value = value.replaceAll(' ','').replace('-', '|')

            // if there is no required `|` in the input throw an error
            if (value.indexOf('|') === -1) {
                const msg = "Missing required pipe character: `|` between numbers.\nFor example, a valid range in-between 10 and 19 would be: 10|19\nThe 2 numbers are inclusive, so in the example, an input of 10 or 19 or anything between would return true."
                this.errors = { message: msg }
                this.fireSimpleErrorAlert(msg)
            } else {
                this.errors = {}
            }

            this.$set(this.model, index, { ...this.model[index], [field]: value });
        },
        moveUp(index, ref) {
            if (index > 0) {
                const innerInputRefs = this.$refs[ref][index - 1].$refs
                innerInputRefs[Object.keys(innerInputRefs)[0]].focus()
            }
        },
        moveUpIcon(index, ref) {
            if (index > 0) this.$refs[ref][index - 1].focus()
        },
        moveDown(index, ref) {
            if (index < this.model.length - 1) {
                const innerInputRefs = this.$refs[ref][index + 1].$refs
                innerInputRefs[Object.keys(innerInputRefs)[0]].focus()
            }
        },
        moveDownIcon(index, ref) {
            if (index < this.model.length - 1) this.$refs[ref][index + 1].focus()
        },
        moveRight(event) {
            event.target.parentElement.nextElementSibling.firstChild.focus()
        },
        moveLeft(event) {
            event.target.parentElement.previousElementSibling.firstChild.focus()
        },
        deleteBtnHandler(row, index) {
            if (row.id) {
                this.scheduledForDelete.push(row)
            }
            this.model.splice(index, 1)
        },
        restoreBtnHandler(row, index) {
            this.scheduledForDelete.splice(index, 1)
            this.model.push(row)
        },
        onSaveHandler: async function () {
            this.loading = true
            this.validate()

            if (this.hasErrors) {
                this.loading = false
                this.fireSimpleErrorAlert(this.variable.name +" - "+ this.errors?.message ?? "There is an error with the lookup value(s) input or output")
                return
            }

            const dto = this.buildDtoModel()
            try {
                const saved = await this.updateVariableLookupValues(this.$store.state.pipelineSlug, this.$store.state.formulaId, this.variableId, dto)

                if (!saved) {
                    await this.fireSimpleErrorAlert('An error occurred while saving')
                    return
                }

                await this.refreshModelFromDB()

                // make sure these are in sync
                this.lookupValues = JSON.parse(JSON.stringify(this.model))

                await swal.fire({
                    text: 'Lookup values successfully updated.',
                    icon: 'success',
                    title: 'Updated',
                })
            } catch (error) {
                if ((error.message = 'GetPipelineVariableFailure')) {
                    this.fireSimpleErrorAlert(error.cause.message)
                    return
                }

                console.log(error)

                this.fireSimpleErrorAlert('Failed to save changes. Please try again later.')
            } finally {
                this.loading = false
            }
        },
        async onReloadHandler() {
            this.loading = true

            try {
                await this.refreshModelFromDB()
            } catch (error) {
                if ((error.message === 'GetPipelineVariableFailure')) {
                    this.fireSimpleErrorAlert(error.cause.message)
                    return
                }

                console.log(error)

                this.fireSimpleErrorAlert('Failed to reload. Please try again later.')
            } finally {
                this.loading = false
            }
        },
        async refreshModelFromDB() {
            const dbVariable = await this.getPipelineVariable(this.variableId, this.$store.state.pipelineSlug, this.$store.state.formulaId)
            this.editable = !dbVariable.has_gone_live || this.$store.state.pipelineSlug === 'shadow'
            this.buildLookupValuesModel(dbVariable.formula_variable_lookup_values)
        },
        addBtnSubLookupValue(index, row) {
            this.model[index].lookup_values.push({
                id: null,
                parent_lookup_value_id: row.id,
                parent_variable_id: '',
                formula_variable_id: null,
                input_value: '',
                output_value: '',
            })
        },
        deleteSubLookupValue(index, index_lookup_value) {
            this.model[index].lookup_values.splice(index_lookup_value, 1)
        },
        buildDtoModel() {
            const deletedIds = this.scheduledForDelete.map(x => x.id)
            const upsert = this.model.map(x => ({
                id: x.id,
                input_value: x.input_value,
                output_value: x.output_value,
                description: x.description,
                lookup_values: x.lookup_values,
            }))

            return {deletedIds, upsert}
        },
        validate() {
            // if there is already an error no need to validate
            if (this.hasErrors) {
                return
            }

            this.errors = this.model.reduce((acc, current) => {
                const e = {}
                if (current.input_value === null || current.input_value === '') e.input_value = 'Required'

                if (current.output_value === null || current.output_value === '')
                    e.output_value = 'Required'

                if (Object.keys(e).length > 0) {
                    Object.assign(acc, {[current.vkey]: e})
                }

                return acc
            }, {})
        },
        buildLookupValuesModel(lookupValues) {
            this.model = []
            this.scheduledForDelete.splice(0, this.scheduledForDelete.length)
            for (const v of lookupValues) {
                this.model.push({...v, vkey: uuid4(), deleted: false})
            }
        },
        addBtnHandler() {
            this.model.push({
                vkey: uuid4(),
                formula_variable_id: this.variableId,
                input_value: '',
                output_value: '',
                description: '',
                lookup_values: [],
            })

            Vue.nextTick(() => {
                const innerInputRefs = this.$refs['input_value'][this.model.length - 1].$refs
                innerInputRefs[Object.keys(innerInputRefs)[0]].focus()
            })
        },
    },
    created: function () {
        this.buildLookupValuesModel(this.lookupValues)
    },
}
</script>

<style scoped>
.content {
    max-height: 63vh;
    overflow: scroll;
    padding-right: 16px;
    scroll-behavior: smooth;
}

.fixed-headers {
    display: flex;
    gap: 16px;
    margin-right: 76px;
}

.fixed-headers h3 {
    margin: 0;
    margin-bottom: 8px;
    width: -webkit-fill-available;
}

.paper {
    border-radius: 4px;
    padding: 16px;
    background-color: white;
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 3px -2px, rgb(0 0 0 / 14%) 0px 2px 4px 0px,
    rgb(0 0 0 / 12%) 0px 1px 8px 0px;
}

.controls {
    gap: 16px;
    display: flex;
    justify-content: space-between;
    padding-right: 16px;
}

.controls-labels {
    width: 75%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.controls-labels.p.b {
    margin-right: 10px;
}

.controls-buttons {
    width: 326px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.alert-danger {
    margin: 0 !important;
    padding: 3px 14px;
}

.b_row {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 10px;
    margin-right: 2px;
}

.b_row .label {
    color: black;
    white-space: nowrap;
}

.justify-flex-end {
    justify-content: flex-end;
}

.action-btn {
    border-radius: 16px;
    border: none;
    transition: all 200ms ease-in-out;
    display: flex;
    justify-content: center;
    height: 30px;
    width: 30px;
    align-items: center;
    background-color: white;
}

.action-btn[disabled] {
    filter: brightness(90%);
}

.action-btn[disabled]:hover {
    transform: unset;
}

.color-green {
    color: green;
}

.color-red {
    color: red;
}

.action-btn:hover {
    transform: scale(1.05);
}

.action-btn:focus-visible {
    outline: none;
    border: solid 1px #4e63ff;
}

.action-btn.color-red:focus-visible {
    box-shadow: rgb(247 82 82 / 41%) 1px 4px 4px -2px, rgb(235 41 41 / 25%) 0px 2px 4px 0px,
    rgb(211 42 42 / 12%) 0px 1px 8px 0px;
    border: solid 1px #ff00003d;
}

.b-shadow {
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 3px -2px, rgb(0 0 0 / 14%) 0px 2px 4px 0px,
    rgb(0 0 0 / 12%) 0px 1px 8px 0px;
}

.v2_btn-primary {
    border: solid #4e63ff 1px;
}

.v2_btn-transparent {
    background: transparent;
}

.v2_btn {
    cursor: pointer;
}

.v2_btn:hover {
    transform: scale(1.015);
    animation: 500ms ease-in-out forwards;
}
</style>
